import { render, staticRenderFns } from "./ShowcaseDocuments.vue?vue&type=template&id=5c46d35e&"
import script from "./ShowcaseDocuments.vue?vue&type=script&lang=ts&"
export * from "./ShowcaseDocuments.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports